import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PrivateRoute = ({ children, adminOnly = false, userOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !user.is_admin) {
    return <Navigate to="/" replace />;
  }

  // We no longer redirect admin users from user-only routes
  // Commented out the restriction so admins can access user functionality
  // if (userOnly && user.is_admin) {
  //   return <Navigate to="/" replace />;
  // }

  return children;
};

export default PrivateRoute;